/*
 * ICOFFEE checkout pages (sections/ic-checkout.liquid): Customer Information → Payment Method → Confirm Purchase →
 * Order Confirmed.
 *
 * live mode     The ICOFFEE app (/apps/icoffee/checkout/…) prices the cart with Shopify's own rates and takes the order.
 *               Cash on delivery creates the order right away; card sends the shopper to Shopify's hosted payment
 *               page. Card details are never typed on these pages. If the app can't take orders, the shopper is
 *               handed to Shopify's own checkout, so an order is always possible.
 * preview mode  Design demo: "Place Order" shows the confirmation screen and empties the cart, but nothing is ordered
 *               or charged. Its card inputs are read only to show the last four digits; never saved, never sent.
 *
 * Contact and address details are kept in sessionStorage so a reload doesn't wipe the form.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ic-co]');
  var cfgEl = document.getElementById('IcCheckoutConfig');
  var info = root && root.querySelector('[data-ic-co-info]');
  if (!root || !cfgEl || !info) return;

  var cfg = JSON.parse(cfgEl.textContent);
  var t = cfg.strings;
  var live = cfg.mode === 'live';
  var KEY = 'ic:checkout';
  var ORDER = ['info', 'payment', 'review'];
  var SHOPIFY_CHECKOUT = '/checkout';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var payment = root.querySelector('[data-ic-co-payment]');
  var review = root.querySelector('[data-ic-co-review]');
  var done = document.querySelector('[data-ic-co-view="done"]');
  var views = { info: info, payment: payment, review: review };
  var cardBox = root.querySelector('[data-ic-co-card]');
  var cardNumber = root.querySelector('[data-ic-co-card-number]');
  var note = root.querySelector('[data-ic-co-note]');
  var summary = root.querySelector('[data-ic-cart-root]');
  var FIELDS = ['phone', 'email', 'name', 'city', 'area', 'street', 'building', 'floor', 'apartment'];

  var saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (err) {}
  // most orders in Egypt are paid on delivery, so that is the first choice when orders are real
  var state = { fields: saved.fields || {}, payment: saved.payment || (live ? 'cod' : 'card'), reached: saved.reached || 'info', step: 'info', location: saved.location || null };

  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ fields: state.fields, payment: state.payment, reached: state.reached, location: state.location })); } catch (err) {}
  }

  function toast(message, tone) {
    if (window.IcAccount && window.IcAccount.toast) window.IcAccount.toast(message, { tone: tone || 'success' });
  }

  function field(name) { return info.elements[name]; }

  function money(amount) {
    return cfg.money.replace('[amount]', Number(amount).toFixed(2));
  }

  /* ---------- customer information ---------- */

  // Egyptian mobile numbers: 01x xxxx xxxx, with or without the country code
  function nationalPhone(value) {
    var digits = String(value || '').replace(/[^\d]/g, '').replace(/^0020/, '').replace(/^20(?=1\d{9}$)/, '').replace(/^0/, '');
    return /^1[0125]\d{8}$/.test(digits) ? digits : '';
  }

  function prettyPhone(national) {
    return '+20 ' + national.slice(0, 3) + ' ' + national.slice(3, 6) + ' ' + national.slice(6);
  }

  function check(name) {
    var el = field(name);
    var value = el.value.trim();
    if (name === 'phone') return value ? (nationalPhone(value) ? '' : t.phone) : t.required;
    if (name === 'email') return !value || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value) ? '' : t.email;
    return value ? '' : t.required;
  }

  function showError(scope, name, message) {
    var box = scope.querySelector('[data-ic-co-error="' + name + '"]');
    if (box) {
      box.textContent = message || '';
      box.hidden = !message;
    }
    var el = scope === info ? field(name) : null;
    if (el) {
      el.setAttribute('aria-invalid', String(!!message));
      el.closest('.ic-co__control').classList.toggle('is-invalid', !!message);
    }
  }

  function validateInfo(focus) {
    var first = null;
    FIELDS.forEach(function (name) {
      var message = check(name);
      showError(info, name, message);
      if (message && !first) first = field(name);
    });
    if (first && focus) first.focus();
    return !first;
  }

  function readInfo() {
    FIELDS.forEach(function (name) { state.fields[name] = field(name).value.trim(); });
    save();
  }

  // fill from the saved draft first, then from the signed-in customer
  FIELDS.forEach(function (name) {
    var el = field(name);
    var value = state.fields[name] || (cfg.customer && cfg.customer[name]) || '';
    if (!value) return;
    if (name === 'phone') value = nationalPhone(value) || value;
    if (el.tagName === 'SELECT') {
      if (Array.prototype.some.call(el.options, function (o) { return o.value === value; })) el.value = value;
    } else {
      el.value = value;
    }
  });

  info.addEventListener('input', function (e) {
    var name = e.target.name;
    if (!name) return;
    if (e.target.getAttribute('aria-invalid') === 'true') showError(info, name, check(name));
    readInfo();
  });

  info.addEventListener('change', function (e) {
    if (e.target.name === 'city') requestQuote();
  });

  info.addEventListener('focusout', function (e) {
    var name = e.target.name;
    if (!name || !e.target.value.trim()) return;
    showError(info, name, check(name));
    // the +20 prefix is already shown, so a valid number drops its country code and leading zero
    if (name === 'phone' && nationalPhone(e.target.value)) {
      e.target.value = nationalPhone(e.target.value);
      readInfo();
    }
  });

  info.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validateInfo(true)) return;
    readInfo();
    go('payment');
  });

  /* ---------- detect my location ---------- */

  var locate = root.querySelector('[data-ic-co-locate]');
  if (locate && !navigator.geolocation) locate.hidden = true;
  if (locate) {
    locate.addEventListener('click', function () {
      locate.setAttribute('aria-busy', 'true');
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          // OpenStreetMap's reverse geocoder turns the coordinates into a governorate, area and street
          var url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&addressdetails=1&lat=' + pos.coords.latitude +
            '&lon=' + pos.coords.longitude + '&accept-language=' + encodeURIComponent(cfg.locale);
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var a = data.address || {};
              if (a.country_code && a.country_code !== 'eg') throw new Error('outside');
              var region = String(a.state || a.province || a.city || '').toLowerCase();
              var city = field('city');
              var option = Array.prototype.filter.call(city.options, function (o) {
                return o.dataset.match.split('|').some(function (word) { return word && region.indexOf(word) > -1; });
              })[0];
              if (option) city.value = option.value;
              var area = a.suburb || a.neighbourhood || a.city_district || a.town || a.village || a.city || '';
              if (area) field('area').value = area;
              if (a.road) field('street').value = a.road;
              if (a.house_number && !field('building').value) field('building').value = a.house_number;
              // the courier gets a map link with the order
              state.location = { lat: pos.coords.latitude, lng: pos.coords.longitude };
              readInfo();
              ['city', 'area', 'street'].forEach(function (name) { showError(info, name, ''); });
              requestQuote();
              toast(t.located);
              (field('street').value ? field('building') : field('street')).focus();
            })
            .catch(function () { toast(t.locate_failed, 'error'); })
            .finally(function () { locate.removeAttribute('aria-busy'); });
        },
        function (err) {
          locate.removeAttribute('aria-busy');
          toast(err && err.code === 1 ? t.locate_denied : t.locate_failed, 'error');
        },
        { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 }
      );
    });
  }

  /* ---------- the ICOFFEE app (live mode) ---------- */

  function api(route, body) {
    return fetch(cfg.proxy + '/' + route, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok || !data || data.ok === false) {
          var error = new Error((data && data.error) || 'http_' + res.status);
          error.code = (data && data.error) || 'http_' + res.status;
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  // what the order will contain, read from Shopify's cart at the moment it is needed
  function cartItems() {
    return fetch(cfg.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return {
          // "_bundle" marks coffees that were added together by Build Your Own Bundle, so the order keeps them together
          items: cart.items.map(function (item) {
            var line = { id: item.variant_id, quantity: item.quantity };
            if (item.properties && item.properties._bundle) line.bundle = String(item.properties._bundle);
            return line;
          }),
          codes: (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }),
          note: cart.note || '',
        };
      });
  }

  // the app has no order permission yet (not_ready), or is not installed or deployed (not_found, a bare 404)
  function appMissing(err) {
    return err.code === 'not_ready' || err.code === 'not_found' || err.code === 'http_404';
  }

  // Shopify's own checkout always works
  function handOver() {
    location.href = SHOPIFY_CHECKOUT;
  }

  /* ---------- totals: Shopify's shipping rate for the chosen governorate ---------- */

  var quoteRun = 0;
  var quoted = null;

  function paintQuote() {
    var shipping = root.querySelector('[data-ic-co-shipping]');
    var total = root.querySelector('[data-ic-co-total]');
    if (!shipping || !total || !quoted) return;
    shipping.classList.toggle('ic-co__pending', !quoted.shipping);
    if (!quoted.shipping) {
      shipping.textContent = t.shipping_pending;
    } else if (quoted.shipping.amount === 0) {
      var free = document.createElement('span');
      free.className = 'ic-totals__free';
      free.textContent = t.free;
      shipping.replaceChildren(free);
    } else {
      shipping.textContent = money(quoted.shipping.amount);
    }
    total.textContent = money(quoted.total);
    paintPoints(quoted.points);
    syncTotal();
  }

  // ICOFFEE points this order earns once it is paid (null while points are off)
  function paintPoints(points) {
    var row = root.querySelector('[data-ic-co-points]');
    if (!row) return;
    row.hidden = !(points > 0);
    if (points > 0) row.querySelector('[data-ic-co-points-value]').textContent = '+' + points;
  }

  function requestQuote() {
    // once the order is placed the cart is empty and there is nothing left to price
    if (!live || !done.hidden) return;
    var run = ++quoteRun;
    root.setAttribute('data-ic-co-quoting', '');
    cartItems()
      .then(function (cart) {
        if (!cart.items.length) return location.reload();
        return api('checkout/quote', { items: cart.items, codes: cart.codes, city: field('city').value });
      })
      .then(function (data) {
        if (run !== quoteRun || !data) return;
        quoted = data.quote;
        paintQuote();
      })
      .catch(function (err) {
        if (run !== quoteRun) return;
        if (appMissing(err)) return handOver();
        // the order request prices the cart again, so a failed estimate doesn't block the shopper
        quoted = null;
      })
      .finally(function () {
        if (run === quoteRun) root.removeAttribute('data-ic-co-quoting');
      });
  }

  /* ---------- payment method ---------- */

  function method() {
    var checked = payment.querySelector('input[name="payment"]:checked');
    return checked ? checked.value : 'cod';
  }

  function cardDigits() { return cardNumber ? cardNumber.value.replace(/\D/g, '') : ''; }

  function syncPayment() {
    var isCard = method() === 'card';
    // the card choice is absent when Theme settings > ICOFFEE checkout has card payments switched off
    if (cardBox) cardBox.hidden = !isCard;
    root.querySelector('[data-ic-co-cod]').hidden = isCard;
    state.payment = method();
    save();
    syncTotal();
  }

  var savedMethod = payment.querySelector('input[name="payment"][value="' + state.payment + '"]');
  if (savedMethod) savedMethod.checked = true;
  payment.addEventListener('change', function (e) {
    if (e.target.name === 'payment') syncPayment();
  });

  payment.addEventListener('input', function (e) {
    var el = e.target;
    if (el === cardNumber) el.value = cardDigits().slice(0, 19).replace(/(\d{4})(?=\d)/g, '$1 ');
    else if (el.hasAttribute('data-ic-co-card-field')) el.value = el.value.replace(/\D/g, '');
    showError(payment, 'card', '');
  });

  // only the design preview has card fields to check
  function validatePayment() {
    if (method() !== 'card' || !cardNumber) return true;
    var extra = payment.querySelectorAll('[data-ic-co-card-field]');
    var month = Number(extra[0].value);
    var ok = cardDigits().length >= 12 && month >= 1 && month <= 12 && extra[1].value.length === 2 && extra[2].value.length >= 3;
    showError(payment, 'card', ok ? '' : t.card);
    if (!ok) (cardDigits().length >= 12 ? extra[0] : cardNumber).focus();
    return ok;
  }

  payment.addEventListener('submit', function (e) {
    e.preventDefault();
    if (validatePayment()) go('review');
  });

  /* ---------- review ---------- */

  function out(name, value, scope) {
    var el = (scope || root).querySelector('[data-ic-co-out="' + name + '"]');
    if (el) el.textContent = value || '';
  }

  function totalText() {
    var el = root.querySelector('[data-ic-total]');
    return el ? el.textContent.trim() : '';
  }

  function fillReview() {
    var f = state.fields;
    var option = field('city').options[field('city').selectedIndex];
    var place = [f.area, option ? option.textContent : f.city, t.country].filter(Boolean).join(t.comma + ' ');
    var building = t.building.replace('[building]', f.building).replace('[floor]', f.floor).replace('[apartment]', f.apartment);
    out('name', f.name);
    out('address', [f.street + t.comma + ' ' + building, place].join('\n'));
    out('phone', prettyPhone(nationalPhone(f.phone)));
    var isCard = state.payment === 'card';
    out('payment', isCard ? t.card_method + (cardNumber ? '' : ' · ' + t.card_line) : t.cod_method + ' · ' + t.cod_line);
    out('card', isCard && cardNumber ? '**** **** **** ' + cardDigits().slice(-4) : '');
    out('note', note.value.trim() || t.no_note);
    syncTotal();
  }

  // the button names the amount, and says "payment" instead of "order" when the card page comes next
  function syncTotal() {
    var label = root.querySelector('[data-ic-co-place]');
    if (!label || !totalText()) return;
    var template = live && state.payment === 'card' ? label.dataset.templateCard : label.dataset.template;
    label.textContent = template.replace('[total]', totalText());
  }

  // a promo code re-renders the summary: price it again (live) and keep the button total in step
  if (summary) {
    new MutationObserver(function (changes) {
      var rerendered = changes.some(function (change) {
        return Array.prototype.some.call(change.addedNodes, function (node) { return node.nodeType === 1 && node.hasAttribute('data-ic-cart-view'); });
      });
      if (!rerendered) return;
      if (live) {
        paintQuote();
        requestQuote();
      } else {
        syncTotal();
      }
    }).observe(summary, { childList: true });
  }

  function saveNote() {
    return fetch(cfg.updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value.trim() }),
    }).catch(function () {});
  }

  var noteEdit = root.querySelector('[data-ic-co-note-edit]');
  noteEdit.addEventListener('click', function () {
    var editing = !note.hidden;
    var label = noteEdit.querySelector('span');
    if (!editing) {
      note.hidden = false;
      root.querySelector('[data-ic-co-out="note"]').hidden = true;
      label.textContent = noteEdit.dataset.done;
      note.focus();
      return;
    }
    note.hidden = true;
    root.querySelector('[data-ic-co-out="note"]').hidden = false;
    label.textContent = t.edit;
    out('note', note.value.trim() || t.no_note);
    saveNote();
  });

  review.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-ic-co-agree') && e.target.checked) showError(review, 'agree', '');
  });

  review.addEventListener('submit', function (e) {
    e.preventDefault();
    var agree = review.querySelector('[data-ic-co-agree]');
    if (!agree.checked) {
      showError(review, 'agree', t.agree);
      agree.focus();
      return;
    }
    if (!validateInfo(false)) return go('info');
    var button = e.submitter || review.querySelector('.ic-co__cta');
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    if (live) placeOrder(button);
    else previewOrder();
  });

  /* ---------- confirmation ---------- */

  function showDone(order) {
    var title = done.querySelector('[data-ic-co-out="order_title"]');
    title.textContent = '';
    // the template is the theme's own text; the order number goes in as text, underlined like the comp
    title.dataset.template.split('[number]').forEach(function (part, i) {
      if (i) {
        var mark = document.createElement('u');
        mark.textContent = order.name;
        title.appendChild(mark);
      }
      title.appendChild(document.createTextNode(part));
    });
    out('order_code', order.code, done);
    out('total', order.total, done);
    // far governorates take longer to reach (3-5 business days in the store's shipping rates)
    var days = done.querySelector('[data-ic-co-days]');
    if (days && (days.dataset.farCodes || '').split(',').indexOf(state.fields.city) > -1) days.textContent = days.dataset.far;
    if (state.fields.email) {
      out('email', state.fields.email, done);
      done.querySelector('[data-ic-co-sent]').hidden = false;
    }
    // points come once the order is delivered and marked paid; a guest collects them by signing up with this email
    var points = done.querySelector('[data-ic-co-points-done]');
    if (points && order.points > 0 && (cfg.signedIn || state.fields.email)) {
      var template = cfg.signedIn ? points.dataset.template : points.dataset.templateGuest;
      points.querySelector('span').textContent = template.replace('[points]', order.points);
      points.hidden = false;
    }
    if (order.statusUrl) {
      done.querySelectorAll('[data-ic-co-status-link]').forEach(function (link) { link.href = order.statusUrl; });
    }
    try { sessionStorage.removeItem(KEY); } catch (err) {}
    root.hidden = true;
    done.hidden = false;
    history.replaceState({ icStep: 'done' }, '', location.pathname + '?step=done');
    window.scrollTo(0, 0);
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.scrollTop = 0;
    title.focus({ preventScroll: true });
    if (window.IcCart) window.IcCart.refresh();
  }

  function clearCart() {
    return fetch(cfg.clearUrl, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } }).catch(function () {});
  }

  /* ---------- place order ---------- */

  // live: the app creates the order (cash on delivery) or the payment page (card)
  function placeOrder(button) {
    var f = state.fields;
    cartItems()
      .then(function (cart) {
        return api('checkout/order', {
          items: cart.items,
          codes: cart.codes,
          city: f.city,
          area: f.area,
          street: f.street,
          building: f.building,
          floor: f.floor,
          apartment: f.apartment,
          name: f.name,
          phone: '0' + nationalPhone(f.phone),
          email: f.email,
          note: note.value.trim(),
          payment: state.payment,
          locale: cfg.locale,
          location: state.location,
        });
      })
      .then(function (data) {
        if (data.payment && data.payment.url) {
          // Shopify's payment page takes over. The cart is kept until the payment is confirmed, so a shopper who
          // turns back loses nothing; assets/ic-cart.js asks the app on the next visit and empties it once paid.
          try {
            localStorage.setItem('ic:payment', JSON.stringify({ draft: data.payment.draft, token: data.payment.token, at: Date.now() }));
          } catch (err) {}
          location.href = data.payment.url;
          return;
        }
        var order = data.order;
        return clearCart().then(function () {
          showDone({ name: order.name, code: order.name, total: money(order.total), statusUrl: order.statusUrl, points: order.points });
        });
      })
      .catch(function (err) {
        button.removeAttribute('aria-busy');
        if (appMissing(err)) return handOver();
        if (err.code === 'invalid' && err.data && err.data.fields) {
          go('info');
          Object.keys(err.data.fields).forEach(function (name) {
            if (field(name)) showError(info, name, name === 'phone' ? t.phone : name === 'email' ? t.email : t.required);
          });
          return;
        }
        if (err.code === 'unavailable' || err.code === 'slow_down') return toast(t[err.code], 'error');
        // anything else: say so, and offer Shopify's own checkout so the order is never stuck
        if (window.IcAccount && window.IcAccount.toast) {
          window.IcAccount.toast(t.order_failed, { tone: 'error', duration: 9000, action: { label: t.use_standard, onClick: handOver } });
        }
      });
  }

  // design preview: nothing is ordered or charged
  function previewOrder() {
    var number = String(100 + Math.floor(Math.random() * 900));
    var total = totalText();
    clearCart().then(function () {
      setTimeout(function () { showDone({ name: '#' + number, code: 'ICO' + number, total: total }); }, reduce.matches ? 0 : 450);
    });
  }

  /* ---------- steps ---------- */

  function allowed(step) {
    return ORDER.indexOf(step) <= ORDER.indexOf(state.reached);
  }

  function go(step, opts) {
    opts = opts || {};
    if (!views[step]) step = 'info';
    if (step !== 'info' && !validateInfo(false)) step = 'info';
    // the preview's card details are never kept, so the review step needs them typed again
    if (step === 'review' && state.payment === 'card' && cardNumber && cardDigits().length < 12) step = 'payment';
    if (ORDER.indexOf(step) > ORDER.indexOf(state.reached)) state.reached = step;
    state.step = step;
    save();

    ORDER.forEach(function (name) {
      var view = views[name];
      view.hidden = name !== step;
      view.classList.remove('is-enter');
    });
    if (step === 'review') fillReview();
    if (!opts.silent && !reduce.matches) {
      void views[step].offsetWidth;
      views[step].classList.add('is-enter');
    }
    root.querySelectorAll('.ic-co__steps [data-ic-co-go]').forEach(function (button) {
      var name = button.dataset.icCoGo;
      button.disabled = !allowed(name);
      if (name === step) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });

    if (!opts.silent) {
      if (opts.pop) history.replaceState({ icStep: step }, '', location.pathname + '?step=' + step);
      else history.pushState({ icStep: step }, '', location.pathname + '?step=' + step);
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) wrapper.scrollTop = 0;
      window.scrollTo(0, 0);
      var heading = views[step].querySelector('.ic-co__heading');
      if (heading) heading.focus({ preventScroll: true });
    }
  }

  root.addEventListener('click', function (e) {
    var button = e.target.closest('[data-ic-co-go]');
    if (!button || button.disabled) return;
    go(button.dataset.icCoGo);
  });

  window.addEventListener('popstate', function (e) {
    if (!done.hidden) return location.reload();
    go((e.state && e.state.icStep) || 'info', { pop: true });
  });

  syncPayment();
  // signing in from this page reloads it: Shopify sends the customer back here with their details prefilled
  var wanted = new URLSearchParams(location.search).get('step');
  go(ORDER.indexOf(wanted) > -1 && allowed(wanted) ? wanted : 'info', { silent: true });
  history.replaceState({ icStep: state.step }, '', location.pathname + '?step=' + state.step);
  requestQuote();
})();
